import type { ReactNode } from "react";
import { Toaster } from "@/components/ui/sonner";
import { useEmbeddedTheme } from "./embedded-appearance";
import { EmbeddedThemeProvider } from "./embedded-theme-provider";

function EmbeddedToaster() {
  return <Toaster position="top-center" theme={useEmbeddedTheme().mode} />;
}

/** 嵌入工作台的浏览器级外壳：外观完全受宿主控制，不挂版本更新或 standalone UI。 */
export function EmbeddedSurface({ children }: { children: ReactNode }) {
  return (
    <EmbeddedThemeProvider>
      {children}
      <EmbeddedToaster />
    </EmbeddedThemeProvider>
  );
}
